import styled from 'styled-components'
import { FONT_SIZE, FONT_WEIGHT } from '@fe/common/constants/main'

export const MessageText = styled.p`
  font-size: ${FONT_SIZE.MEDIUM};
  font-weight: ${FONT_WEIGHT.SEMIBOLD};
`
